import { render, staticRenderFns } from "./Competences.vue?vue&type=template&id=1c9476fe&"
import script from "./Competences.vue?vue&type=script&lang=js&"
export * from "./Competences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports